import {scrollTo} from "./scrollTo";

export function progressbar() {
  let
    doc = document,
    docEl = doc.documentElement,
    body = doc.body,
    progressbar = doc.querySelector('.progressbar'),
    $progressbar = $(progressbar),
    progress = progressbar.querySelector('i'),
    scroll,
    getScroll = function () {
     return (docEl['scrollTop'] || body['scrollTop']);
    },
    setScrollProgress = function () {
      scroll = getScroll() / ((docEl['scrollHeight'] || body['scrollHeight']) - docEl.clientHeight) * 100;
      progress.style.height = scroll + '%';
      scroll == 100 ? $progressbar.addClass('reverse') : $progressbar.removeClass('reverse');
    };

  doc.addEventListener('scroll', function () {
    setScrollProgress();
  });

  doc.addEventListener('orientationchange', function () {
    setScrollProgress();
  });

  doc.addEventListener('resize', function () {
    setScrollProgress();
  });

  setScrollProgress();

  $progressbar.on('click', '.scroll-down', function (e) {
    e.preventDefault();

   /* let operation = $progressbar.hasClass('reverse') ? "-1" : 1;
    scrollTo(parseInt(getScroll() +  (window.innerHeight * operation)));*/

    scrollTo($progressbar.hasClass('reverse') ? 0 : parseInt(getScroll() +  window.innerHeight));
  });
}




// WEBPACK FOOTER //
// ./assets/js/modules/progressbar.js